import React, { useEffect, ReactNode } from 'react';
import { useAppStore } from '../stores';
import { useThemeConfig } from '../hooks/queries';

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const { themeConfig, setThemeConfigFromStorage } = useAppStore();

  // 使用 React Query 加载主题配置
  const { data: loadedThemeConfig, isLoading } = useThemeConfig();

  // 仅将存储中的主题同步到 store，不写回 storage，避免触发 syncService 动态导入导致加载卡住
  useEffect(() => {
    if (loadedThemeConfig && loadedThemeConfig !== themeConfig) {
      setThemeConfigFromStorage(loadedThemeConfig);
    }
  }, [loadedThemeConfig, themeConfig, setThemeConfigFromStorage]);

  // 应用主题到 DOM
  useEffect(() => {
    if (!isLoading && themeConfig) {
      document.documentElement.classList.toggle('dark', themeConfig.mode === 'dark');
    }
  }, [themeConfig?.mode, isLoading]);

  // 即使加载中也要渲染 children，避免空白页面
  return <>{children}</>;
};
